import React, { useState } from 'react';

import { Tabs } from '@components/index';
import { feeCollectionTabOptions } from '@features/lead-management/constants/common';
import { TabPill } from 'types/tabs';

import AddToBranchGroupTab from './AddToBranchGroupTab';
import PaymentTab from './PaymentTab';

const FeeCollectionTab: React.FC<{ leadId?: string }> = ({ leadId }) => {
  const [selectedTab, setSelectedTab] = useState<TabPill>(
    feeCollectionTabOptions[0]
  );
  const onTabChange = (tab: TabPill) => {
    setSelectedTab(tab);
  };

  const renderTabContent = () => {
    switch (selectedTab.id) {
      case 1:
        return <PaymentTab leadId={leadId} />;
      case 2:
        return <AddToBranchGroupTab leadId={leadId} />;
      default:
        return null;
    }
  };
  return (
    <div className="relative min-h-175 rounded-xl bg-white p-6">
      <Tabs
        tabs={feeCollectionTabOptions}
        selectedTab={selectedTab}
        onTabSelect={onTabChange}
        className="!w-1/2"
      />
      {renderTabContent()}
    </div>
  );
};

export default FeeCollectionTab;
